export default __webpack_public_path__ + "static/media/avater9.b76b1da3.png";